var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio",class:{'radio--warning':_vm.type == 'warning', 'radio--success':_vm.type == 'success', 'radio--cancel':_vm.type == 'cancel'}})
}
var staticRenderFns = []

export { render, staticRenderFns }